// extracted by mini-css-extract-plugin
module.exports = {"container":"addtooltip_container__ybG2L","tooltip":"addtooltip_tooltip__2PAf3"};